<template>
<b-container fluid class="my-5 p-lg-5">
    <!-- User Interface controls -->
    <b-alert :show="dismissCountDown" fade dismissible variant="success" class="mt-4" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
        {{this.alertMessage}}
    </b-alert>
    <b-row>
        <b-col lg="6" class="my-1">
            <b-form-group label="Sort" label-for="sort-by-select" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0" v-slot="{ ariaDescribedby }">
                <b-input-group size="sm">
                    <b-form-select id="sort-by-select" v-model="sortBy" :options="sortOptions" :aria-describedby="ariaDescribedby" class="w-75">
                        <template #first>
                            <option value="">-- none --</option>
                        </template>
                    </b-form-select>

                    <b-form-select v-model="sortDesc" :disabled="!sortBy" :aria-describedby="ariaDescribedby" size="sm" class="w-25">
                        <option :value="false">Asc</option>
                        <option :value="true">Desc</option>
                    </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>

        <b-col lg="6" class="my-1">
            <b-form-group label="Initial sort" label-for="initial-sort-select" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0">
                <b-form-select id="initial-sort-select" v-model="sortDirection" :options="['asc', 'desc', 'last']" size="sm"></b-form-select>
            </b-form-group>
        </b-col>

        <b-col lg="6" class="my-1">
            <b-form-group label="Filter" label-for="filter-input" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Type to Search"></b-form-input>

                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>

        <b-col sm="5" md="6" class="my-1">
            <b-form-group label="Per page" label-for="per-page-select" label-cols-sm="6" label-cols-md="4" label-cols-lg="3" label-align-sm="right" label-size="sm" class="mb-0">
                <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"></b-form-select>
            </b-form-group>
        </b-col>

    </b-row>
<b-skeleton-wrapper class="my-5" :loading="loading">
<template #loading>
<b-skeleton-table
  :rows="7"
  :columns="5"
  :table-props="{ bordered: true, striped: true }"
> </b-skeleton-table>
</template>
    <!-- Main table element -->
    <b-table :items="items" class="my-5" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filter-included-fields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" stacked="md" show-empty small @filtered="onFiltered">
        <template #cell(name)="row">
            {{ row.value }}
        </template>

        <template #cell(actions)="row">
            <b-button-toolbar>
                <b-button-group>

                    <b-button variant="outline-secondary" size="sm" @click="row.toggleDetails" class="">
                        <b-icon icon="arrows-expand"></b-icon>
                    </b-button>
                    <b-button variant="outline-secondary" :to="'view/'+ encrpytQuoteId(row.item.id)" size="sm">
                        <b-icon icon="eye"></b-icon>
                    </b-button>
                    <b-button @click="notifyCopySuccess()" :data-clipboard-text="'https://quoter.co.nz/' + getShortUrl(encrpytQuoteId(row.item.id))" variant="outline-secondary" size="sm" class="clipboard">
                        <b-icon icon="link"></b-icon>
                    </b-button>                       
                    <b-button v-if="showButton(row.item.Status)" variant="outline-secondary" :to="'quote/'+ row.item.id" size="sm">
                        <b-icon icon="gear"></b-icon>
                    </b-button>
                  
                    <b-button variant="outline-secondary" @click="duplicateQuote(row.item.id)" size="sm">
                        <b-icon icon="files"></b-icon>
                    </b-button>
                     
  
                    <b-button variant="outline-secondary" @click="deleteQuote(row)" size="sm">
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </b-button-group>
            </b-button-toolbar>
        </template>

        <template #row-details="row">
            <b-card>
                <ul class="m-0 p-0">
                    <li class="d-flex justify-content-between my-2 py-2 px-3 bg-secondary text-white" v-for="(value, key) in filterDetails(row.item.QuoteItems)" :key="key" v-html="value">{{ value }}</li>
                </ul>
            </b-card>
        </template>
    </b-table>
   
    <b-row>
        <b-col sm="7" md="6">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" align="fill" size="sm" class="my-0"></b-pagination>
        </b-col>
    </b-row>
    </b-skeleton-wrapper>
    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
        <pre>{{ infoModal.content }}</pre>
    </b-modal>
</b-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import clipboard from "clipboard";

new clipboard('.clipboard');

export default {
    data() {
        return {
            items: [],
            fields: [{
                    key: 'id',
                    label: 'ID',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'QuoteNumber',
                    label: 'Quote Number',
                    sortable: true,
                },                
                {
                    key: 'Client',
                    label: 'Client Name',
                    sortable: true,
                },
                {
                    key: 'Title',
                    label: 'Title',
                    sortable: true,
                },
                {
                    key: 'Date',
                    label: 'Date',
                    sortable: true,
                },
                {
                    key: 'Expiry',
                    label: 'Expiry Date',
                    sortable: true,
                },              
                {
                    key: 'Status',
                    label: 'Status',
                    sortable: true,
                },
                {
                    key: 'UpdatedAt',
                    label: 'Last Updated',
                    sortable: true,
                },                
                {
                    key: 'actions',
                    label: 'Actions'
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100, {
                value: 300,
                text: "Show a lot"
            }],
            sortBy: 'id',
            sortDesc: true,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: ''
            },
            dismissSecs: 5,
            dismissCountDown: 0,
            alertMessage:'',
            loading:true
        }
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    }
                })
        }
    },
    async beforeCreate(){
        this.$root.requiresUserAuth()
    },
    async mounted() {

        // Set the initial number of items

        /* eslint-disable */
        if(this.$route.params.saveSuccess){
            this.showAlert(this.$route.params.message);
        }
        try {
            const response = await axios.get('/api/quotes',
                    {
                    headers: {
                    Authorization:
                        `Bearer ${this.$store.state.userJWT}`,
                    },
                }            
            );
            this.items = response.data.map((quote) => {
                console.log(quote);
                return {
                    id: quote.id,
                    QuoteNumber: quote.QuoteNumber,
                    Date: moment(quote.Date).format('DD/MM/YY'),
                    Expiry: moment(quote.Expiry).format('DD/MM/YY'),
                    Title: quote.Title,
                    Status: this.formatStatus(quote.Status),
                    Total: '$' + quote.Total,
                    Client: this.formatClient(quote.Client),
                    UpdatedAt: moment(quote.updated_at).format('DD/MM/YY HH:mm'),
                    QuoteItems: quote.QuoteItem
                };
            })
            this.totalRows = this.items.length
            this.loading = false
            console.log(this.rows)
        } catch (error) {
            console.log(error);
        }

    },
    methods: {
        notifyCopySuccess(){
            this.showAlert('Quote URL has been copied to the clipboard (Can be sent to client for quote viewing)');
        },
        getShortUrl(hash){
            return hash.substring(0,8);
        },
        filterDetails(QuoteItems){
            console.log(QuoteItems)
            let data = []
            Object.keys(QuoteItems).forEach(function (key) {
                data.push('<span>' + QuoteItems[key].Item + '</span> <span>$' + QuoteItems[key].TotalValue + '</span>' )
            });
            return data
        },
        encrpytQuoteId(id){
            return this.$root.encrpytQuoteId(id)
        },
        showButton(Status){ 
            var Status = Status.toLowerCase();
            if(Status == 'accepted' || Status == 'declined' || Status == 'sent'){
                return false;
            }else{
                return true;
            }
            
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert(message) {
            this.alertMessage = message;
            this.dismissCountDown = this.dismissSecs
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        formatClient(Client) {
            if (!Client) {
                return 'No Client Name'
            } else {
                return Client.Name
            }
        },
        formatStatus(Status) {
            if (!Status) {
                return 'No Status'
            } else {
                return Status[0].toUpperCase() + Status.slice(1);
            }
        },        
        duplicateQuote(id) {
            this.$router.push({
                name: 'duplicateQuote',
                params: {
                    duplicateQuoteId: id
                }
            })
        },
        deleteQuote(row) {

            const confirmDelete = confirm('Are you sure you want to delete this quote? It will be gone for good. Click "OK" to delete.');
            if (confirmDelete == true) {
                axios
                    .delete("/api/quotes/" + row.item.id,
                        {
                        headers: {
                        Authorization:
                            `Bearer ${this.$store.state.userJWT}`,
                        },
                    }            
                    )
                    .then(response => {
                        const index = this.items.findIndex(item => item.id == row.item.id)
                        this.items.splice(index, 1);
                        this.showAlert('Successfully deleted quote');
                    })
                    .catch(error => {
                        console.log(error)
                        this.$root.handleError(error.response)
                    })

            }
        }
    }
}
</script>
